import { createIcon } from './create-icon'

export const Underline = createIcon({
  displayName: 'Underline',
  paths: [
    'M341.333 213.333c23.564 0 42.667 19.103 42.667 42.667v213.333c0 70.694 57.306 128 128 128s128-57.306 128-128v-213.333c0-23.564 19.102-42.667 42.667-42.667s42.667 19.103 42.667 42.667v213.333c0 117.82-95.514 213.333-213.333 213.333s-213.333-95.514-213.333-213.333v-213.333c0-23.564 19.103-42.667 42.667-42.667zM682.667 853.333c23.565 0 42.667-19.102 42.667-42.667s-19.102-42.667-42.667-42.667h-341.333c-23.564 0-42.667 19.102-42.667 42.667s19.103 42.667 42.667 42.667h341.333z'
  ]
})
